import React from 'react';

const HQPlayerStateContext = React.createContext({
  historyState: null,
  setHistoryState: () => {},
});

export default HQPlayerStateContext;
